// Actions/StudentAdminAction.js
import api from "../../lib/api/api";
import {
  FETCH_STUDENTS_FAILURE,
  FETCH_STUDENTS_REQUEST,
  FETCH_STUDENTS_SUCCESS,
} from "../Actions/types";

// Action to fetch all students
export const fetchAllStudents = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_STUDENTS_REQUEST });

    try {
      const response = await api.get(`/admin/all`); // Adjust your endpoint here
      const students = response.data;

      console.log("API Response:", students); // Log API response

      dispatch({
        type: FETCH_STUDENTS_SUCCESS,
        payload: students,
      });
    } catch (error) {
      console.log("API Error:", error); // Log any API error
      dispatch({
        type: FETCH_STUDENTS_FAILURE,
        payload: error.message,
      });
    }
  };
};
